import {useQuery} from 'react-query'
import {LanguageEditModalForm} from './LanguageEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getLanguageById} from '../core/_requests'

const LanguageEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: language,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-language-${itemIdForUpdate}`,
    () => {
      return getLanguageById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <LanguageEditModalForm isLanguageLoading={isLoading} language={{id: undefined}} />
  }

  if (!isLoading && !error && language) {
    console.log({language, },"its language")
    console.log(typeof language,"its language")
    return <LanguageEditModalForm isLanguageLoading={isLoading} language={language} />
  }

  return null
}

export {LanguageEditModalFormWrapper}
